import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconHandling = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="M8 0c4.4 0 8 3.6 8 8 0 4.433-3.6 8-8 8a7.98 7.98 0 0 1-8-8c0-4.4 3.567-8 8-8Zm0 2.133c-2.9 0-5.267 2.1-5.767 4.8h2.834a2.157 2.157 0 0 1 1.866-1.066h2.1c.8 0 1.467.433 1.867 1.066h2.833c-.5-2.7-2.866-4.8-5.733-4.8ZM2.233 9.067a5.816 5.816 0 0 0 4.7 4.7V11.2L5.3 9.067H2.233Zm6.8 4.7a5.816 5.816 0 0 0 4.7-4.7h-3.1l-1.6 2.133v2.567Z"
    />
  </svg>
));
export default SvgIconHandling;
